import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'

export type FeatureDiscoveryPopUpArrowProps = {
    /** the type which determines the position on the y-axis (e.g. TOP or BOTTOM) */
    type: 'TOP' | 'BOTTOM'
    /** the position on the x-axis which can be a number or a percentage string (array also possible) */
    positionX?: number | string | number[] | string[]
}

const ARROW_HEIGHT = 8
const ARROW_WIDTH = 12

const FeatureDiscoveryPopUpArrow: FC<FeatureDiscoveryPopUpArrowProps> = ({ type, positionX }) => (
    <Grid
        height={0}
        width={0}
        position="absolute"
        top={type === 'TOP' ? -ARROW_HEIGHT : undefined}
        bottom={type === 'BOTTOM' ? -ARROW_HEIGHT : undefined}
        left={positionX || '50%'}
        right={0}
        marginLeft={`-${ARROW_WIDTH / 2}px`}
        marginRight="auto"
        borderTop={type === 'TOP' ? 0 : ARROW_HEIGHT}
        borderBottom={type === 'TOP' ? ARROW_HEIGHT : 0}
        borderX={ARROW_WIDTH / 2}
        borderTopColor={type === 'TOP' ? 'TRANSPARENT' : 'ORANGE'}
        borderBottomColor={type === 'TOP' ? 'ORANGE' : 'TRANSPARENT'}
        borderXColor="TRANSPARENT"
    />
)

export default FeatureDiscoveryPopUpArrow
